export default __webpack_public_path__ + "static/nytt-ikon-figma-ffe912fb3dacf7b9a7aaac0de61f4663.png";